import React from "react"
import { initialCustomerPartQueryParams } from "@ncs/ncs-api"
import { Box, SelectEcomm, useUrlState, TrackingEvent } from "@ncs/web-legos"
import { PartSearchResultsUrlState } from "../PartSearchResults"
import { useAnalytics } from "~/hooks/useAnalytics"
import { css } from "@emotion/react"

const sortOptions = [
	{ value: "-visit_count", text: "Popular" },
	{ value: "title", text: "Name A - Z" },
	{ value: "-title", text: "Name  Z - A" },
	{ value: "price", text: "Price low to high" },
	{ value: "-price", text: "Price high to low" },
	{ value: "online_part_number", text: "Product number" },
]

type PartSortUrlState = Pick<PartSearchResultsUrlState, "ordering" | "page">

export const PartSortEcomm: React.FC = React.memo(() => {
	const [{ ordering }, { setUrlState }] = useUrlState<PartSortUrlState>({
		ordering: initialCustomerPartQueryParams.ordering,
	})
	const { trackEvent } = useAnalytics()

	const sortByHandler = (newValue: string | null) => {
		setUrlState({ ordering: newValue, page: 1 })
		trackEvent(TrackingEvent.SORT_BY_LIST)
		trackEvent(TrackingEvent.SORT_BY_OPTION, { option: newValue })
	}

	return (
		<Box display="flex" flexShrink={0} alignItems="center" ml={1}>
			<label htmlFor="sort-by" css={sortLabel}>
				Sort by:{" "}
			</label>

			<SelectEcomm
				options={sortOptions}
				value={ordering ?? "-visit_count"}
				showNoSelectionOption={false}
				onChange={sortByHandler}
				mb={0}
				selectId="sort-by"
			/>
		</Box>
	)
})

const sortLabel = css`
	margin-right: 0.75rem;
	font-weight: 500;
	font-size: 0.875rem;
`
